import { call, put, takeLatest } from "redux-saga/effects";
import { 
   ARTICLE_DETAILS_DATA, ARTICLE_LIST_DATA, 
   GET_ARTICLE_DETAILS_API, GET_ARTICLE_LIST_DATA_API,
   ADD_CATEGORY_ARTICLE_API,ADD_CATEGORY_ARTICLE_DATA,
   LOAD_CATEGORY_ARTICLE_DATA_DETAIL,LOAD_CATEGORY_ARTICLE_DATA_DETAIL_API,
   UPDATE_CATEGORY_ARTICLE_API,UPDATE_CATEGORY_ARTICLE_DATA,
   ADD_CATEGORY_ARTICLE_S3_DATA, ADD_CATEGORY_ARTICLE_S3_API,
   CATEGORY_ARTICLE_LIST_API, CATEGORY_ARTICLE_LIST_DATA,
  } from "./Constants";
import { 
  setArticleDetailsFail, setArticleDetailsSuccess, 
  setArticleListDataFail, setArticleListDataSuccess,
  setCategoryArticleAddDataFail, setCategoryArticleAddDataSuccess,
  setCategoryArticleDetailDataSuccess,  setCategoryArticleDetailDataFail,
  setCategoryArticleUpdateDataSuccess, setCategoryArticleUpdateDataFail,  
  setCategoryArticleAddS3DataSuccess, setCategoryArticleAddS3DataFail,
  setCategoryArticleListDataFail, setCategoryArticleListDataSuccess,
 } from "./Actions";
import { addErrorAlert, addSuccessAlert } from "../../../alert/Actions";
import { ticketApi } from "../../../../shared/components/Service";

function* getCategoryArticleListDataService() {
  try {
    const response = yield call(ticketApi.get, CATEGORY_ARTICLE_LIST_API);
    if (response.status === 200) {
      yield put(setCategoryArticleListDataSuccess(response.data));
    } else {
      yield put(addErrorAlert(response.response?.data?.msg || "Failed to load Articles"));
      yield put(setCategoryArticleListDataFail(response.response?.data));
    }
  } catch (error) {
    yield put(addErrorAlert("Error retrieving Article List"));
    yield put(setCategoryArticleListDataFail(error));
  }
}



// Worker Saga
function* getArticleListDataService(action) {
  try {
    const search = action.search || "";

    const url = search
      ? `${GET_ARTICLE_LIST_DATA_API}?search=${search}`
      : GET_ARTICLE_LIST_DATA_API;

    const response = yield call(ticketApi.get, url);

    if (response.status === 200) {
      const data = response.data;
      yield put(setArticleListDataSuccess(data));
    } else {
      yield put(addErrorAlert(response.response?.data?.msg || "Failed to load Articles"));
      yield put(setArticleListDataFail(response.response?.data));
    }
  } catch (error) {
    yield put(addErrorAlert("Error retrieving Article List"));
    yield put(setArticleListDataFail(error));
  }
}

function* getArticleDetailsService(action) {
  try {
    const { id } = action;

    const url = `${GET_ARTICLE_DETAILS_API}/${id}`;

    const response = yield call(ticketApi.get, url);

    if (response.status === 200) {
      yield put(setArticleDetailsSuccess(response.data.data));
    } else {
      yield put(addErrorAlert("Failed retrieving Article Details"));
      yield put(setArticleDetailsFail(response.response.data));
    }
  } catch (error) {
    yield put(addErrorAlert("Error retrieving Article Details"));
    yield put(setArticleDetailsFail(error));
  }
}
function* postCategoryArticleDataService({ request }) {
    try {
        const response = yield call(ticketApi.post ,ADD_CATEGORY_ARTICLE_API , request );
        if (response.status === 201) {
            yield put(addSuccessAlert("Category updated"))
            yield put(setCategoryArticleAddDataSuccess(response.data.data));
        } else {
            yield put(addErrorAlert(response.response.data.msg || "Error adding Category"))
            yield put(setCategoryArticleAddDataFail(response.response.data))
        }
    } catch (error) {
        yield put(addErrorAlert("Error adding Category"))
        yield put(setCategoryArticleAddDataFail(error))
    }
}

function* getArticleDetailDataService({ id }) {
    try {
      const response = yield call(ticketApi.get, LOAD_CATEGORY_ARTICLE_DATA_DETAIL_API + id);
      const status = response.status;

      if (status === 200) {
        const newData = response.data.data; 
   
        yield put(setCategoryArticleDetailDataSuccess(newData));
      } else {
        yield put(setCategoryArticleDetailDataFail(response.response.data.msg));
      }
    } catch (error) {
      yield put(setCategoryArticleDetailDataFail(error));
    }
  }

  function* updateCategoryArticleDataService({ id, request }) {
  try {
    const response = yield call(
      ticketApi.put,
     UPDATE_CATEGORY_ARTICLE_API + id,
      request
    );

    if (response.status === 200) {
      yield put(addSuccessAlert("Article updated successfully"));
      yield put(setCategoryArticleUpdateDataSuccess(response.data.data));
    } else {
      yield put(addErrorAlert(response.response.data.msg));
      yield put(setCategoryArticleUpdateDataFail(response.response.data));
    }
  } catch (error) {
    yield put(addErrorAlert("Could not update Article"));
    yield put(setCategoryArticleUpdateDataFail(error));
  }
}

function* postCategoryArticleS3DataService({ request }) {
  try {
    const formData = new FormData();

    formData.append("file", request.file);
    formData.append("category_config_id", request.category_config_id);
    formData.append("title", request.title);
    formData.append("content", request.content);

    const response = yield call(
      ticketApi.post,
      ADD_CATEGORY_ARTICLE_S3_API,
      formData
    );

    if (response.status  === 200) {
      yield put(setCategoryArticleAddS3DataSuccess(response.data.data));
    } else {
      yield put(setCategoryArticleAddS3DataFail(response.data));
    }
  } catch (error) {
    yield put(setCategoryArticleAddS3DataFail(error));
  }
}

// Watcher Saga
export  function* articleListSaga() {
  yield takeLatest(ARTICLE_LIST_DATA.GET_ARTICLES_REQUEST, getArticleListDataService);
  yield takeLatest(ADD_CATEGORY_ARTICLE_DATA.ADD_CATEGORY_ARTICLE_DATA_LOAD, postCategoryArticleDataService);
  yield takeLatest(LOAD_CATEGORY_ARTICLE_DATA_DETAIL.LOAD_CATEGORY_ARTICLE_DATA_DETAIL_LOAD, getArticleDetailDataService);
  yield takeLatest(UPDATE_CATEGORY_ARTICLE_DATA.UPDATE_CATEGORY_ARTICLE_DATA_LOAD, updateCategoryArticleDataService);
  yield takeLatest(ADD_CATEGORY_ARTICLE_S3_DATA.ADD_CATEGORY_ARTICLE_S3_DATA_LOAD, postCategoryArticleS3DataService);
  yield takeLatest(CATEGORY_ARTICLE_LIST_DATA.CATEGORY_ARTICLE_LIST_DATA_LOAD, getCategoryArticleListDataService);
}

export  function* articleDetailsSaga() {
  yield takeLatest(ARTICLE_DETAILS_DATA.GET_ARTICLE_DETAILS_REQUEST,getArticleDetailsService);
}